import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
export const WhoIsRavenForSection = ({ className }: { className?: string }) => {
  useLocale();

  return (
    <section className={className}>
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        {/* Badge */}
        <span className="mb-4 inline-block rounded-full bg-landing-pill-bg px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('landing.whoIsRavenFor2')}{' '}
        </span>

        {/* Heading */}
        <h2 className="mb-3 font-bold font-libre-baskerville text-4xl text-landing-heading">
          {t('landing.builtForTeamsThatVerifyIdentities')}{' '}
        </h2>

        {/* Subtitle */}
        <p className="mb-6 text-landing-body text-sm">
          {t('landing.forOrganizationsThatNeedReliableKycAndKyb')}{' '}
        </p>

        {/* Body paragraph 1 */}
        <p className="mb-4 text-landing-body text-sm leading-relaxed">
          {t('landing.ravenIsDesignedForOrganizationsThatNeedToVerify')}{' '}
          <span className="font-libre-baskerville font-semibold text-landing-heading-sm">
            {t('landing.handlingSensitiveIdentityInformation')}{' '}
          </span>
          {t('copy.audience')}{' '}
          <span className="font-semibold text-primary">
            {t('landing.banksNeobanksFintechCompaniesGovernmentInstitutions')}{' '}
          </span>
          {t('landing.andAnyOrganizationResponsibleForValidatingClientIdentities')}{' '}
        </p>

        {/* Body paragraph 2 */}
        <p className="mb-8 text-landing-body text-sm leading-relaxed">
          {t('landing.thePlatformIsBuiltSo')}{' '}
          <span className="font-semibold text-primary underline decoration-primary/40 underline-offset-2">
            {t('landing.complianceAndVerificationOfficers')}{' '}
          </span>{' '}
          {t('landing.canReviewClientsQuicklyAndEfficientlyWhile')}{' '}
          <span className="font-libre-baskerville font-semibold text-landing-heading-sm italic">
            {t('landing.managersAndDecisionMakers')}{' '}
          </span>{' '}
          {t('landing.canEasilyMonitorTheEntireProcessAndMaintainFull')}{' '}
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap items-center gap-3">
          <a
            className="rounded-md bg-primary px-5 py-2.5 font-semibold text-primary-foreground text-sm transition hover:opacity-90"
            href="#contact"
          >
            {t('landing.bookADemo')}{' '}
          </a>
          <a
            className="rounded-md border border-primary px-5 py-2.5 font-semibold text-primary text-sm transition hover:bg-primary/5"
            href="#our-solution"
          >
            {t('landing.exploreSolution')}{' '}
          </a>
        </div>
      </div>
    </section>
  );
};
